module.exports = __webpack_public_path__ + "static/social-tw-49d46f5652082b5fee6138a949a8d15b.png";